import { JsonObject, JsonProperty } from "json2typescript";
import { FundingAgency } from "./FundingAgency";

@JsonObject("SearchOptions")
export class SearchOptions {

    @JsonProperty("firstName", String)
    public firstName: string = ""

    @JsonProperty("lastName", String)
    public lastName: string = ""

    @JsonProperty("keyPhrase", String)
    public keyPhrase: string = ""

    @JsonProperty("isProposalAwardChecked", Boolean)
    public isProposalAwardChecked: boolean = true

    @JsonProperty("isFacultyChecked", Boolean)
    public isFacultyChecked: boolean = true

    @JsonProperty("isSponsorChecked", Boolean)
    public isSponsorChecked: boolean = true

    @JsonProperty("isPublicationChecked", Boolean)
    public isPublicationChecked: boolean = true

    @JsonProperty("isTitleChecked", Boolean)
    public isTitleChecked: boolean = true

    @JsonProperty("isAbstractChecked", Boolean)
    public isAbstractChecked: boolean = true  
    
    @JsonProperty("startYear", Number)
    public startYear: number = 0;

    @JsonProperty("endYear", Number)
    public endYear: number = 0;

    @JsonProperty("agencies", [])
    public agencies: FundingAgency[] = []

}


// WEBPACK FOOTER //
// ./src/models/SearchOptions.ts